html {
    font-family: Inter, sans-serif;
    font-display: swap;
}

body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: auto !important; /* This makes + symbols render vertically centered */
}

mark.pdf-highlight {
    background-color: #eaca9b;
}

mark.pdf-highlight.active {
    background-color: #e3a84f;
}

@font-face {
    font-family: 'Inter';
    src: url('/fonts/inter/Inter-VariableFont.ttf') format('truetype');
    font-weight: 400 500 700;
    font-stretch: normal;
    font-style: oblique 0deg 20deg;
}
